<template>
  <button type="button" class="delivery-country" @click="handlerOpenCountriesModal">
    <svg class="delivery-country-icon" viewBox="0 0 20 20">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0501 3.26632C6.30344 3.26632 3.2662 6.30356 3.2662 10.0502C3.2662 13.7968 6.30344 16.8341 10.0501 16.8341C13.7967 16.8341 16.8339 13.7968 16.8339 10.0502C16.8339 6.30356 13.7967 3.26632 10.0501 3.26632ZM1.75867 10.0502C1.75867 5.47098 5.47086 1.75879 10.0501 1.75879C14.6293 1.75879 18.3415 5.47098 18.3415 10.0502C18.3415 14.6294 14.6293 18.3416 10.0501 18.3416C5.47086 18.3416 1.75867 14.6294 1.75867 10.0502Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0501 1.75879C10.2564 1.75879 10.4536 1.84333 10.5959 1.99272C12.491 3.98252 13.6184 6.57018 13.7946 9.29643H17.5877C18.004 9.29643 18.3415 9.6339 18.3415 10.0502C18.3415 10.4665 18.004 10.804 17.5877 10.804H13.7946C13.6184 13.5302 12.491 16.1179 10.5959 18.1077C10.4536 18.2571 10.2564 18.3416 10.0501 18.3416C9.84378 18.3416 9.64651 18.2571 9.50424 18.1077C7.60919 16.1179 6.48173 13.5302 6.30557 10.804H2.51243C2.09614 10.804 1.75867 10.4665 1.75867 10.0502C1.75867 9.6339 2.09614 9.29643 2.51243 9.29643H6.30557C6.48173 6.57018 7.60919 3.98252 9.50424 1.99272C9.64651 1.84333 9.84378 1.75879 10.0501 1.75879ZM7.81672 10.804C7.96998 12.8683 8.74963 14.837 10.0501 16.4461C11.3505 14.837 12.1302 12.8683 12.2834 10.804H7.81672ZM12.2834 9.29643H7.81672C7.96998 7.23207 8.74963 5.26336 10.0501 3.65426C11.3505 5.26336 12.1302 7.23207 12.2834 9.29643Z"
      />
    </svg>

    <span class="delivery-country-text"> {{ countryText }}</span>

    <svg class="delivery-country-arrow">
      <use xlink:href="#svg-select"></use>
    </svg>
  </button>
</template>

<script lang="ts" setup>
import useModal from '@use/useModal/useModal';
import DeliveryCountryModal from '@components/Header/DeliveryCountry/DeliveryCountryModal.vue';

import { useStore } from '@/store';
import { computed } from 'vue';

const { state } = useStore();

const messages = computed(() => state?.results?.deliveryCountries?.messages);
const countriesList = computed(() => state?.results?.deliveryCountries?.items);

const modal = useModal();
const handlerOpenCountriesModal = () => {
  modal.show(DeliveryCountryModal, {}, { width: '696px' });
};

const getCurrentDeliveryCountry = computed(() =>
  countriesList?.value?.find((el) => el.isUserCountry)
);

const countryText = computed(() => {
  if (getCurrentDeliveryCountry.value?.UF_NAME) {
    return `${messages.value?.yourDeliveryCountry}: ${getCurrentDeliveryCountry.value?.UF_NAME}`;
  }
  return messages.value?.title;
});
</script>

<style lang="scss" scoped>
.delivery-country {
  display: flex;
  align-items: center;
  background-color: transparent;
  cursor: pointer;
  margin-right: 24px;
  text-align: start;
  transition: 0.2s linear color;
  &:hover {
    color: var(--color-link-hover);
  }
}
.delivery-country-icon {
  width: 20px;
  height: 20px;
  fill: currentColor;
  flex-shrink: 0;
  margin-right: 12px;
  @include point-lg {
    margin-right: 4px;
  }
}
.delivery-country-arrow {
  width: 20px;
  height: 20px;
  fill: currentColor;
  flex-shrink: 0;
}
.delivery-country-text {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%;
}
</style>
